import { Injectable, HostListener, OnDestroy, ɵConsole } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { StorageEnum } from '../utilities/storage.enum';

export class dataStorage {
    accion: StorageEnum;
    key: string;
    newValue: string;
    oldValue: string;
}

@Injectable({providedIn:"root"})
export class StorageService implements OnDestroy {
    private sessionStorageSub = new Subject<dataStorage>();
    private inicializacion:boolean = false;

    constructor(){
    }

    ngOnDestroy(): void {
        this.sessionStorageSub.complete();
        this.sessionStorageSub.unsubscribe();
    }

    watchSessionStorage(): Observable<any> {
        if(!this.inicializacion){
            this.inicializacion = true;
            window.addEventListener("storage", (event) =>{
                if(event.storageArea.length == 0){
                    let dataStor:dataStorage = new dataStorage();
                    dataStor.accion = StorageEnum.remove;
                    this.sessionStorageSub.next(dataStor);
                }
            });
        }
        return this.sessionStorageSub.asObservable();
    }

    setItem(key:string, data:string, changeKey?:string) {
        try {
            if(data){
                let dataStor:dataStorage = new dataStorage();
                if(sessionStorage.getItem(key)===null || sessionStorage.getItem(key)===""){
                    sessionStorage.setItem(key, data);
                    dataStor.accion = StorageEnum.add;
                    dataStor.key = (changeKey)?changeKey:key;
                    dataStor.newValue = data;
                    this.sessionStorageSub.next(dataStor);
                }else{
                    dataStor.oldValue = sessionStorage.getItem(key);
                    sessionStorage.setItem(key, data);
                    dataStor.accion = StorageEnum.update;
                    dataStor.key = (changeKey)?changeKey:key;
                    dataStor.newValue = data;
                    this.sessionStorageSub.next(dataStor);
                } 
            }   
        } catch (error) {
            alert("error => " + error);
            console.error("dataStorage.setItem",error);
        }
    }

    getItem(key: string):string{
        return sessionStorage.getItem(key);
    }

    ifExist(key: string):boolean{
        let isExist:boolean = false;
        try {
            if(sessionStorage.getItem(key)!==null && sessionStorage.getItem(key)!==""){
                isExist = true;
            }
        } catch (error) {
            isExist = false;
            console.error("isExistItem.catch",error);
        }
        return isExist;
    }

    removeItem(key) {
        let dataStor:dataStorage = new dataStorage();
        sessionStorage.removeItem(key);
        dataStor.accion = StorageEnum.remove;
        this.sessionStorageSub.next(dataStor);
    }

    clear(){
        let dataStor:dataStorage = new dataStorage();
        sessionStorage.clear();
        dataStor.accion = StorageEnum.removeAll;
        this.sessionStorageSub.next(dataStor);
    }


}